import React from 'react';
import { Create, SimpleForm, TextInput, ReferenceInput, SelectInput } from 'react-admin';

const isHierarchy = false; // expects true or false injected by plop

export const PriorityLevelCreate = (props) => {
    const defaultReferenceSort = { field: "name_path", order: "ASC" }
    return (
    <Create {...props}>
        <SimpleForm redirect='list'>
            <TextInput fullWidth label="Priority Level Name" source="text" />
            {(isHierarchy) && <ReferenceInput
                reference="kelloggs_priority_level"
                source="parent"
                perPage={500}
                fullWidth
                sort={defaultReferenceSort}
                filterToQuery={(searchText) => ({ 'name_path@ilike':  `${encodeURIComponent(searchText)}` })}
            >
            <SelectInput
                optionText="name_path"
            />
            </ReferenceInput>}
        </SimpleForm>
    </Create>
)};
export default PriorityLevelCreate